export default function arrayEquals<T>(a: T[] | null | undefined, b: T[] | null | undefined): boolean {
	if (a === b || a == null && b == null) {
		return true;
	}

	if (a == null || b == null) {
		return false;
	}

	if (a.length !== b.length) {
		return false;
	}


	return a.every((x: any, i: number): boolean => x === b[i]);

}
